import {TreeSelect} from "antd";
import React, { useEffect, useRef, useState } from "react";
import {TreeSelectProps} from "antd/lib/tree-select";

/**
 * **Extends functionality of TreeSelect from 'antd'**
 *
 * Adds:
 * -   Save search query
 */
const TreeSelectWrapper = (props: TreeSelectProps & {children: React.ReactNode}) => {
    const {onFocus, onBlur, onSearch, searchValue, ...remainingProps} = props;

    const [wrapperSearchValue, setSearchValue] = useState(searchValue || "");
    const didBlur = useRef(false);
    
    useEffect(() => {
        setSearchValue(searchValue || "")
    }, [searchValue])

    const defaultOnFocus = (e: React.FocusEvent<HTMLElement>) => {
        wrapperOnSearch(wrapperSearchValue);
    }

    const defaultOnBlur = (e: React.FocusEvent<HTMLElement>) => {
        didBlur.current = true;
        setTimeout(() => {
            didBlur.current = false;
        }, 20);
    }

    const wrapperOnSearch = (value: string) => {
        if (value === "") {
            // delay check to see if empty string occured due to onBlur
            setTimeout(() => {
                if (!(didBlur.current)) {
                    setSearchValue("");
                    onSearch && onSearch(value);
                }
            }, 10);
            return;
        };

        setSearchValue(value);

        if (onSearch) {
            onSearch(value);
        }
    }
    
    const wrapperOnFocus = (e: React.FocusEvent<HTMLElement>) => {
        if (props.onFocus) {
            props.onFocus(e);
        }; 
        defaultOnFocus(e)
    };

    const wrapperOnBlur = (e: React.FocusEvent<HTMLElement>) => {
        if (props.onBlur) {
            props.onBlur(e); 
        }
        defaultOnBlur(e)
    };

    return <TreeSelect
        onFocus={wrapperOnFocus} 
        onBlur={wrapperOnBlur}
        onSearch={wrapperOnSearch}
        searchValue={wrapperSearchValue} 
        {...remainingProps}
    >
    </TreeSelect>
}

export default TreeSelectWrapper;
